import { InputNumber } from "antd";
import styled from "styled-components";

export const StyledInputNumber = styled(InputNumber)`
  &.renderbus-ui--input-number {
    background: #2c2c31;

    border: 1px solid transparent;
    &.ant-input-number-affix-wrapper:not(
        .ant-input-number-affix-wrapper-disabled
      ):hover {
      border-color: #13cb75;
    }
    &.ant-input-number-affix-wrapper:focus,
    .ant-input-number-affix-wrapper-focused {
      border-color: #13cb75;
      box-shadow: none;
    }
    &.ant-input-number-affix-wrapper {
      border: 1px solid transparent;
      &.ant-input-number-affix-wrapper-focused {
        box-shadow: 0px 0px 0px 2px rgba(19, 203, 117, 0.14);
      }
      &:focus,
      &:hover {
        border: 1px solid #13cb75;
        box-shadow: 0px 0px 0px 2px rgba(19, 203, 117, 0.14);
        border-radius: 4px;
      }
    }
    .ant-input-number-input {
      &::placeholder {
        color: rgba(255, 255, 255, 0.65) !important;
        font-size: 14px;
      }
    }
    &.ant-input-number {
      background: #2c2c31;
      border-radius: 2px;
      color: rgba(255, 255, 255, 0.85);
      font-size: 14px;
      border: 1px solid transparent;
      .ant-input-number-input {
        height: 30px;
        &::placeholder {
          color: rgba(255, 255, 255, 0.65) !important;
        }
      }
      &:focus {
        border-color: transparent;
        box-shadow: none;
      }
    }
    &.ant-input-number-disabled {
      color: #7e8486;
    }
    .ant-input-number-prefix {
      margin-right: 4px;
    }
    .ant-input-number {
      margin-left: 10px;
    }
  }
`;
